import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class MeasureFavoritesService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getFavorites(userId: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/users/${userId}/measure-favorites`);
  }

  addFavorite(userId: string, measureCode: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/users/${userId}/measure-favorites`, { measureCode });
  }

  removeFavorite(userId: string, measureCode: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/users/${userId}/measure-favorites/${measureCode}`);
  }
}
